import Vue from "vue";

const state = {
}
const getters = {
    filter: (state) => state,
}

const mutations = {
    updateFilter(state, payload) {
        console.log("payload",payload)
        Vue.set(state, "data", payload);
    },
}

export default {
    state,
    getters,
    mutations,
}
